export const alphabeticalSorter = (right: { id: string; name: string }, left: { id: string; name: string }) =>
  right.name.localeCompare(left.name);
